var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x94\x84 Icon 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.645 8L12 13.3433L17.355 8L19 9.645L13.0607 15.5843C12.4749 16.1701 11.5251 16.1701 10.9393 15.5843L5 9.645L6.645 8Z",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownInitial);
export default __webpack_public_path__ + "static/media/dropdownInitial.7d8eee6fc7fd87aa36138d79020f1802.svg";
export { ForwardRef as ReactComponent };